import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

const BookingSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-dark-background p-6">
      <div className="bg-white dark:bg-dark-foreground shadow-lg rounded-lg p-6 text-center max-w-md">
        <FaCheckCircle className="text-green-500 text-6xl mx-auto mb-4" />
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">Booking Confirmed!</h2>
        <p className="text-gray-600 dark:text-gray-400 mt-2">Your ticket has been successfully booked.</p>
        
        <button
          onClick={() => navigate("/gift-cards/travel")}
          className="mt-4 bg-[rgb(180,249,76)] text-black font-semibold py-2 px-4 rounded-lg transition duration-200"
        >
          Search Again
        </button>
      </div>
    </div>
  );
};

export default BookingSuccess;
